import React from 'react'
import { Link } from 'react-router-dom'

export interface ReminderCardProps {
    repetition: string
    time: string
    until: string
    textMsg: string
    reminderID: string
}

export function ReminderCard({ repetition, time, until, textMsg, reminderID }: ReminderCardProps) {
    return (
        <div className="rounded-2xl box-border w-full p-4 bg-white shadow-[rgba(18,18,64,0.06)_0px_8px_12px_0px]">
            <div className="flex flex-row justify-between mb-1 items-center">
                <h1 className="text-xl font-medium">แจ้งเตือนของฉัน</h1>
                <Link to={`/optimus/edit-reminder?id=${reminderID}`}>
                    <button className="border-2 text-primary-blue py-2 px-4 rounded-xl active:bg-bright-light-blue active:text-white font-medium">
                        แก้ไข
                    </button>
                </Link>
            </div>
            <div className="flex flex-col">
                <span>{repetition}</span>
                <span>{time}</span>
                <span>{until}</span>
            </div>
            <div className="bg-line-bg-color box-border px-4 py-3 mt-4 rounded-xl">
                <div className="text-white text-sm font-medium">ตัวอย่างข้อความแจ้งเตือน</div>
                <div className="relative -mb-6">
                    <img
                        src={require('../../../assets/thunder_line_icon.svg')}
                        className="h-10 mt-3"
                        alt="mt-icon"
                    />
                    <img
                        className="absolute"
                        style={{
                            top: '9px',
                            left: '44px',
                            width: '9.5px',
                            height: '12.5px',
                        }}
                        src={require('../../../assets/line_bubble_tail.svg')}
                    />
                    <div
                        className="bg-white rounded-xl py-2 px-3 relative font-line w-fit"
                        style={{
                            top: '-34px',
                            left: '52px',
                            maxWidth: 'calc(100% - 52px)',
                        }}
                    >
                        {textMsg}
                    </div>
                </div>
            </div>
        </div>
    )
}
